import React from "react"
import { compose } from "recompose"
import cn from "classnames"
import { Flex } from "@infotech/uikit-grid"
import IssueStatus from "../components/IssueStatus"
import Link from "../components/Link"
import withEquipment from "./withEquipment"
import withTechCard from "./withTechCard"
import styles from "../styles.css"

const Row = ({ title, children }) => (
  <div className={styles.row}>
    <span
      className={cn([styles[`secondary-attention-font`], styles[`field-name`]])}
    >
      {title}
    </span>
    <div className={styles[`main-attention-font`]}>{children}</div>
  </div>
)

const SecondaryInfo = ({
  issue: {
    id: issueId,
    statusId,
    customFields: { object_code: objectCode } = {},
  } = {},
  equipment: { info: equipmentInfo } = {},
  sapIssueId,
  techCard: { external_code: techCardName, internal_code: techCardCode } = {},
}) => (
  <div className={styles[`secondary-info`]}>
    <h3 className={styles[`subtitle-font`]}>Дополнительная информация</h3>
    <Flex column>
      {sapIssueId && <Row title="Номер в КИСУР">{sapIssueId}</Row>}
      {issueId && (
        <Row title="Номер заявки">
          <Link
            className={styles[`link-font`]}
            to={`/issue/read/${issueId}`}
            title={issueId}
          />
        </Row>
      )}
      {statusId && (
        <Row title="Статус заявки">
          <IssueStatus statusId={statusId} />
        </Row>
      )}
      {objectCode && (
        <Row title="Объект">
          <Link
            className={styles[`link-font`]}
            to={`/equip/read/${objectCode}`}
            title={equipmentInfo}
          />
        </Row>
      )}
      {techCardCode && (
        <Row title="Технологическая карта">
          <Link
            className={styles[`link-font`]}
            to={`/taskCard/read/${techCardCode}`}
            title={techCardName}
          />
        </Row>
      )}
    </Flex>
  </div>
)

const enhance = compose(withEquipment, withTechCard)

export default enhance(SecondaryInfo)
